import { render } from "./joinWxGroup.vue?vue&type=template&id=421a4ab8&scoped=true"
import script from "./joinWxGroup.vue?vue&type=script&lang=js"
export * from "./joinWxGroup.vue?vue&type=script&lang=js"

import "./joinWxGroup.vue?vue&type=style&index=0&id=421a4ab8&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421a4ab8"]])

export default __exports__